<template>
    <div class="show-analytics">
        <template v-if="show.hosted">
            <div class="widget-wrap">
                <analytics-widget :current-show-hash="show.hash">
                    <template v-slot="{ range, ready }">
                        <div
                            v-for="(component, index) in panels"
                            :key="index"
                            class="panel"
                        >
                            <component
                                :is="component"
                                :from="range.from"
                                :ready="ready"
                                :show-hash="show.hash"
                                :to="range.to"
                                wait-until-ready
                            />
                        </div>
                    </template>
                </analytics-widget>
            </div>
        </template>
        <hosting-call-to-action
            v-else
            screen="analytics"
            :show="show"
        />
    </div>
</template>

<script>

/**
 * Internal dependencies
 */
import AnalyticsWidget from '@/components/Analytics/Widget';
import HostingCallToAction from '@/components/Shows/HostingCallToAction';
import Platforms from '@/components/Analytics/Platforms';
import Sources from '@/components/Analytics/Sources';

export default {
    components: {
        AnalyticsWidget,
        HostingCallToAction,
        Platforms,
        Sources,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },

    data: () => ({
        panels: [
            'Sources',
            'Platforms',
        ],
    }),
};
</script>
